import React from "react"
import { OverlayTrigger, Button, Popover } from "react-bootstrap"
import UAI from "../UAI"

const PopOverDatosEncuesta = (props) => {
  if (UAI.cohorteSinDatosEncuesta(props.cohorte, props.encuesta)) {
    return ""
  }

  if (UAI.cohorteSinMedicionEncuesta(props.cohorte, props.encuesta)) {
    return "Sin medición"
  }

  let datosEncuesta = null
  let errorDatos = null
  if (props.cohorte["parsed_" + props.encuesta]) {
    if (props.encuesta === "encuesta_docente") {
      let avgRespuestas = 0
      if (Array.isArray(props.cohorte["parsed_" + props.encuesta])) {
        props.cohorte["parsed_" + props.encuesta].forEach((encuesta) => {
          avgRespuestas += encuesta["Muestra"]
        })
        avgRespuestas = (
          avgRespuestas / props.cohorte["parsed_" + props.encuesta].length
        ).toFixed(0)
      }
      datosEncuesta = {
        preguntas: null,
        respuestas: avgRespuestas,
      }
    } else {
      datosEncuesta = {
        preguntas: props.cohorte["parsed_" + props.encuesta].preguntas,
        respuestas: props.cohorte["parsed_" + props.encuesta].respuestas,
      }
    }
  } else {
    try {
      datosEncuesta = JSON.parse(props.cohorte[props.encuesta])
      datosEncuesta = {
        preguntas: datosEncuesta.preguntas,
        respuestas: datosEncuesta.respuestas,
      }
    } catch (e) {
      console.log(
        "Error parseando JSON resultados de Encuesta docente! " +
          props.cohorte.id
      )
      errorDatos = e.message
    }
  }

  if (!datosEncuesta && !errorDatos) {
    return ""
  }

  return (
    <>
      <OverlayTrigger
        className="encuestasPopover"
        trigger="focus"
        placement="left"
        overlay={
          <Popover>
            <Popover.Header>{props.encuesta}</Popover.Header>
            <Popover.Body>
              <textarea
                cols="50"
                rows="10"
                defaultValue={
                  props.cohorte[props.encuesta]
                    ? props.cohorte[props.encuesta].toString()
                    : ""
                }
              ></textarea>
            </Popover.Body>
          </Popover>
        }
      >
        <Button id={props.encuesta + "-" + props.cohorte.id} type="button">
          {errorDatos && <div>Error</div>}
          {!errorDatos && <div>{datosEncuesta.respuestas} respuestas</div>}
        </Button>
      </OverlayTrigger>
    </>
  )
}

export default PopOverDatosEncuesta
